import { createFileRoute } from '@tanstack/react-router'
import { guardStudentOnly } from '@/lib/auth/routeGuards'
import AttestationRequest from '@/components/studentPage/AttestationRequest'

export const Route = createFileRoute('/student/attestation')({
  beforeLoad: guardStudentOnly,
  component: AttestationRequest,
})



